(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wijha-sayedaboutus"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();

    const padNumber = (value) => String(value).padStart(2, '0');

    const initialize = (root) => {
      if (!root || instances.has(root)) return;

      const track = root.querySelector('[data-wjq-track]');
      const slides = Array.from(root.querySelectorAll('[data-wjq-slide]'));
      const leftButton = root.querySelector('[data-wjq-direction="left"]');
      const rightButton = root.querySelector('[data-wjq-direction="right"]');
      const currentOutput = root.querySelector('[data-wjq-current]');
      const progressBar = root.querySelector('[data-wjq-progress]');

      if (!track || slides.length === 0) return;

      const controller = new AbortController();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let currentIndex = 0;
      let scrollFrame = 0;

      const getVisibleCount = () => {
        const firstSlide = slides[0];
        if (!firstSlide) return 1;

        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        const slideWidth = firstSlide.getBoundingClientRect().width;

        if (slideWidth <= 0) return 1;
        return Math.max(1, Math.round((track.clientWidth + gap) / (slideWidth + gap)));
      };

      const getLastIndex = () => Math.max(0, slides.length - getVisibleCount());

      const getClosestIndex = () => {
        const trackRight = track.getBoundingClientRect().right;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().right - trackRight);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return Math.min(closestIndex, getLastIndex());
      };

      const update = (index) => {
        const lastIndex = getLastIndex();
        currentIndex = Math.max(0, Math.min(index, lastIndex));

        if (currentOutput) currentOutput.textContent = padNumber(currentIndex + 1);
        if (rightButton) rightButton.disabled = currentIndex <= 0;
        if (leftButton) leftButton.disabled = currentIndex >= lastIndex;

        if (progressBar) {
          const progress = lastIndex === 0 ? 100 : ((currentIndex + 1) / (lastIndex + 1)) * 100;
          progressBar.style.width = `${progress}%`;
        }
      };

      const move = (direction) => {
        const startingIndex = getClosestIndex();
        const change = direction === 'left' ? 1 : -1;
        const nextIndex = Math.max(0, Math.min(startingIndex + change, getLastIndex()));
        const target = slides[nextIndex];

        if (!target) return;

        target.scrollIntoView({
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start'
        });

        update(nextIndex);
      };

      leftButton?.addEventListener('click', () => move('left'), { signal: controller.signal });
      rightButton?.addEventListener('click', () => move('right'), { signal: controller.signal });

      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          move('left');
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          move('right');
        }
      }, { signal: controller.signal });

      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => update(getClosestIndex()));
      }, { passive: true, signal: controller.signal });

      const resizeObserver = new ResizeObserver(() => update(getClosestIndex()));
      resizeObserver.observe(track);

      window.requestAnimationFrame(() => update(getClosestIndex()));

      instances.set(root, {
        destroy() {
          controller.abort();
          resizeObserver.disconnect();
          window.cancelAnimationFrame(scrollFrame);
          instances.delete(root);
        }
      });
    };

    const initializeAll = (scope = document) => {
      if (scope.matches?.('[data-wjq-section]')) initialize(scope);
      scope.querySelectorAll?.('[data-wjq-section]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches?.('[data-wjq-section]')
        ? event.target
        : event.target.querySelector?.('[data-wjq-section]');

      instances.get(root)?.destroy();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
